import {Component, Input, Type} from '@angular/core';

@Component({
  selector: 'app-mai-tab',
  template: '',
})
export class MaiTabComponent {
  @Input() isPap: boolean = true;
  @Input() title: string = '';
  @Input() labelEnum = '';
  @Input() disabled = false;
  @Input() component: Type<any>;
}
